import { PaginationRequest } from '../config/common'

export class PaginationSubcontractorNoteRequest extends PaginationRequest {
    note?: string = '';
    subcontractorID?: string = ''
}
 
export interface CreateSubcontractorNoteRequest {
    note?: string;
    subcontractorID?: string;
}